const checkIsCanalPlusLP = (): boolean => window.location.href.includes('canal-plus') || false;
const checkIsAmazonLP = (): boolean => window.location.href.includes('amazon') || false;

export { checkIsCanalPlusLP, checkIsAmazonLP };